import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useChartPeriod } from '@/hooks';
import {
  CurrencyValue,
  DisplaySwitch,
  Flex,
  LineChart,
  formatNumber
} from '@blockanalitica/ui';
import { useCallback, useMemo, useState } from 'react';

export default function HistoricTabs() {
  const [activeDisplayOption, setActiveDisplayOption] = useState('debt');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const displayOptions = useMemo(
    () => [
      { key: 'debt', value: 'Debt' },
      { key: 'collateral', value: 'Collateral' }
    ],
    []
  );

  const [data, error] = useApi({
    url: '/groups/grove/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const yScaleValueFormatter = useCallback(
    (value) => {
      switch (activeDisplayOption) {
        case 'debt':
          return `${formatNumber(value)}`;
        default:
          return `$${formatNumber(value)}`;
      }
    },
    [activeDisplayOption]
  );

  const valueFormatter = useCallback(
    (value) => {
      switch (activeDisplayOption) {
        case 'debt':
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: {
                  name: 'DAI',
                  address: '0x6b175474e89094c44da98b954eedeac495271d0f'
                },
                iconSize: '3'
              }}
            />
          );
        default:
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: 'USD',
                iconSize: '3'
              }}
            />
          );
      }
    },
    [activeDisplayOption]
  );

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <LineChart
          key={activeDisplayOption}
          data={data}
          datasets={[
            {
              xField: 'date',
              yField: activeDisplayOption
            }
          ]}
          yScaleValueFormatter={yScaleValueFormatter}
          valueFormatter={valueFormatter}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }
  return <ChartSkeleton />;
}
